import React from 'react'
import { TextColorYellow } from '../../styles/atoms/StyledComponents'
import { ImageContainer, ImageMe, Info, InfoAboutContainer, InfoContainer } from './styles'
import TextTitle from './title-h3/TextTitle'


export const InfoAboutMe = () => {
  return (
    <InfoAboutContainer>
      
      <ImageContainer>
        <ImageMe
          src="/img/photo-me.jpg"
          alt="Foto de Perfil" 
        />
      </ImageContainer>

      <InfoContainer>

        <div>
          <TextTitle
            text="About"
            stylesElement={{
              fontSize: "2rem",
              marginTop: '50px',
              fontSize_lg: "3rem",
            }}
          />
          <Info>I am a self-taught <TextColorYellow>web developer </TextColorYellow>who loves everything related to the world of computers and linux, i love to learn new things every day </Info>
        </div>
      </InfoContainer>

    </InfoAboutContainer>
  )
}

